export default __webpack_public_path__ + "static/media/code.98d05029.svg";